<div class="text-start container mt-5 p-5">
        <h1 class="text-center mb-3">CONTRAT DE PARTENARIAT - CHARTE DE CONFORMITÉ STUDIOMAP</h1>

        <p>La société STUDIOMAP, société par actions simplifiée, immatriculée au RCS de Créteil sous le numéro
                894 479 443, ayant son siège social au 23 Rue Blondel, 75002 Paris, représentée par Monsieur ATTIA
                Jeremy, ci-après dénommée "STUDIOMAP", </p>

        <h5 class="mt-5">Préambule :</h5>
        <p>Créée le 2 novembre 2020, la société STUDIOMAP est une plateforme dédiée à l’organisation et à la réservation
                de studios d'enregistrement, de photographie, et de vidéos en ligne. En utilisant les services de
                STUDIOMAP, les parties acceptent sans réserve les présentes conditions générales de partenariat et
                d’utilisation (CGPU), ainsi que la charte de conformité.</p>

        <h5 class="mt-5">1. Objet :</h5>
        <p>Le présent contrat définit les termes de la collaboration entre STUDIOMAP et l'EXPLOITANT DE STUDIO, ainsi
                que les obligations de chaque partie dans le cadre de la mise à disposition des services de réservation
                via la plateforme STUDIOMAP.</p>

        <h5 class="mt-5">2. Conditions spécifiques applicables aux EXPLOITANTS DE STUDIOS :</h5>

        <h5 class="mt-5">2.1 Enregistrement et vérification des informations</h5>
        <p>L'EXPLOITANT DE STUDIO doit créer un compte sur la plateforme STUDIOMAP, fournir des informations complètes
                et exactes sur son studio (description, localisation, équipements, disponibilité, prix, etc.), et les
                maintenir à jour.</p>

        <h5 class="mt-5">2.2 Gestion des fiches studio</h5>
        <p>L'EXPLOITANT DE STUDIO est responsable de la création et de la gestion de sa fiche studio sur la plateforme.
                Chaque fiche doit être conforme aux standards de qualité imposés par STUDIOMAP. Les contacts personnels
                ne doivent pas figurer dans la description des studios.</p>

        <h5 class="mt-5">2.3 Commissions STUDIOMAP</h5>
        <p>STUDIOMAP perçoit une commission de <strong>15 % TTC</strong> après chaque réservation. Ces commissions
                couvrent les frais
                liés à la mise en relation, à la promotion des annonces, ainsi qu’à la maintenance de la plateforme.
                Elles sont prélevées automatiquement sur le prix horaire TTC du studio. Le reste est reversé au
                prestataire selon les modalités définies.</p>

        <h5 class="mt-5">2.4 Fixation et modification des prix</h5>
        <p>L'EXPLOITANT DE STUDIO fixe librement les prix de ses services, incluant les taxes et autres charges
                applicables. Toute modification de prix doit être communiquée explicitement à STUDIOMAP au moins 30
                jours à l’avance. Ces modifications entreront en vigueur après ce délai.</p>

        <h5 class="mt-5">2.5 Engagements liés à la réservation</h5>
        <p>L'EXPLOITANT DE STUDIO s'engage à fournir l'accès au studio et les services tels que décrits dans la fiche
                studio pour chaque réservation acceptée. Les studios sont tenus de répondre aux réservations et aux
                sollicitations de STUDIOMAP dans les plus brefs délais.</p>

        <h5 class="mt5">2.6 Responsabilité des contenus publiés</h5>
        <p>L'EXPLOITANT DE STUDIO est entièrement responsable des contenus qu'il publie sur la plateforme (textes,
                images, vidéos). Ces contenus doivent respecter les exigences de STUDIOMAP, notamment l'interdiction
                d'afficher des coordonnées personnelles dans la description du studio.</p>

        <h5 class="mt-5">3 Conditions spécifiques applicables aux UTILISATEURS :</h5>

        <h5 class="mt-5">3.1 Enregistrement des utilisateurs</h5>
        <p>Les UTILISATEURS peuvent s’inscrire gratuitement sur la plateforme. Ils peuvent demander la clôture de leur
                compte en contactant expressément le service client de STUDIOMAP, qui s’engage à supprimer le compte
                dans un délai de 48 heures après la demande.</p>

        <h5 class="mt-5">3.2 Procédure de réservation</h5>
        <p>Les UTILISATEURS doivent respecter les conditions spécifiques de l'EXPLOITANT DE STUDIO lors de la
                réservation. L'annulation d'une réservation n'est possible que jusqu'à 48 heures avant le début de la
                séance. Les acomptes ne sont pas remboursés, sauf si le studio n’a pas rempli son obligation d'effectuer
                la séance acceptée.</p>

        <h5 class="mt-5">4 Responsabilité de STUDIOMAP :</h5>

        <h5 class="mt-5">4.1 Sécurisation et disponibilité de la plateforme</h5>
        <p>
                STUDIOMAP met en œuvre tous les moyens nécessaires pour assurer la sécurité et la disponibilité de la
                plateforme 24/7, sauf en cas de maintenance ou de circonstances indépendantes de sa volonté.</p>

        <h5 class="mt-5">4.2 Limitation de responsabilité</h5>
        <p>STUDIOMAP ne garantit pas l'absence totale d'erreurs ou d'interruptions sur la plateforme et décline toute
                responsabilité pour les intrusions, les virus, ou toute autre mauvaise utilisation de la plateforme par
                les MEMBRES.</p>

        <h5 class="mt-5">4.3 Clause de non-garantie</h5>
        <p>STUDIOMAP ne garantit pas la disponibilité continue des services et n’est pas responsable des interruptions
                ou dysfonctionnements temporaires.</p>

        <h5 class="mt-5">5 Responsabilité des MEMBRES :</h5>
        <h5 class="mt-5">5.1 Obligations des membres</h5>
        <p>Les MEMBRES sont responsables de l’utilisation de leur compte. En cas de violation des présentes conditions,
                STUDIOMAP se réserve le droit de désactiver le compte concerné et de résilier le contrat de partenariat.
        </p>

        <h5 class="mt-5">6 Dispositions générales :</h5>
        <h5 class="mt-5">6.1 Modification des conditions générales</h5>
        <p>STUDIOMAP se réserve le droit de modifier les présentes CGPU en fonction des évolutions légales,
                technologiques, ou des besoins du marché. Toute modification sera communiquée aux MEMBRES et leur
                acceptation sera requise pour continuer à utiliser les services.</p>

        <h5 class="mt-5">6.2 Réglementation des transactions</h5>
        <p>Les transactions sur la plateforme sont gérées via un service de paiement interne sécurisé, fourni par
                Stripe, Inc., une entreprise spécialisée dans le traitement des paiements en ligne. Stripe est
                enregistré sous le numéro EIN 26-0374781, et son siège social est situé au 354 Oyster Point Blvd, South
                San Francisco, CA 94080, États-Unis.</p>

        <h5 class="mt-5">6.3 Confidentialité et protection des données personnelles</h5>
        <p>STUDIOMAP protège les données personnelles des MEMBRES conformément à la législation applicable, notamment le
                RGPD. Les MEMBRES ont le droit de consulter, rectifier, ou supprimer leurs données sur simple demande.
        </p>

        <h5 class="mt-5">6.4 Propriété intellectuelle</h5>
        <p>Tous les éléments de la plateforme STUDIOMAP sont la propriété exclusive de STUDIOMAP ou de ses partenaires.
                Toute reproduction ou utilisation non autorisée est strictement interdite.</p>

        <h5 class="mt-5">6.5 Loi applicable et juridiction compétente</h5>
        <p>Le présent contrat est régi par le droit français. En cas de litige, les parties s’engagent à rechercher une
                solution amiable avant toute action judiciaire. À défaut, les tribunaux compétents de Créteil seront
                seuls compétents.</p>

        <h5 class="mt-5">7 Contact :</h5>
        <p>Pour toute question ou information supplémentaire, les MEMBRES peuvent contacter STUDIOMAP via la rubrique «
                Nous contacter » sur la plateforme, ou par courrier à l'adresse suivante : <br>
                23 Rue Blondel, 75002 Paris, France. <br>
                Numéro SIREN : 894 479 443 <br>
                Numéro SIRET (siège) : 894 479 443 00018 <br> Numéro TVA Intracommunautaire : FR77894479443 Numéro RCS
                Créteil B 894 479 443</p>

</div>